<div class="dashboard" *ngIf="!metadataLoading">
  <div class="container-fluid dashboard-body">
    <div class="title-and-dropdowns">
      <h1 class="dashboard-title">{{ kpiService.title }}</h1>
      <div class="filter-dropdown-and-text">
        <p class="dropdown-header">Filter By</p>
        <div class="dropdowns">
          <ng-select
            #filterCategoryDropdown
            [items]="filterCategories"
            bindLabel="text"
            bindValue="id"
            (change)="selectFilterCategory()"
            [(ngModel)]="selectedCategory"
            [clearable]="false"
            [searchable]="false"
            placeholder="- Select a filter -"
            data-cy="DistrictProfileFilterCategorySelect"
            *ngIf="filterCategories.length > 1"
          >
          </ng-select>
          <ng-select
            #filterSubcategoryDropdown
            [items]="filterSubcategories"
            bindLabel="text"
            bindValue="id"
            (change)="selectFilterSubcategory()"
            [(ngModel)]="selectedSubcategory"
            [clearable]="false"
            [searchable]="false"
            placeholder="- Select a filter -"
            data-cy="DistrictProfileFilterSubcategorySelect"
            *ngIf="filterSubcategories.length > 0"
          >
          </ng-select>
          <button
            mat-raised-button
            color="primary"
            class="clear-filter-button"
            (click)="clearFilters()"
          >
            Clear Filters
          </button>
        </div>
      </div>
    </div>
    <div
      *ngFor="
        let panel of metadata.customerFramework?.customerPanels;
        trackBy: trackPanelFn
      "
    >
      <panel
        [metadata]="panel"
        [level]="metadata.entityLevel"
        [role]="role"
        [hasAllSchools]="hasAllSchools"
        [tier]="tier"
        [filterCategory]="selectedCategory"
        [filterValue]="selectedSubcategory"
        (clearFilterEvent)="clearFilters()"
        #Panel
      ></panel>
    </div>
  </div>
</div>
